import React from 'react';
import styled from 'styled-components';
import PilotCompanyLogo from './imageComponents/PilotCompanyLogo';
import PropTypes from 'prop-types';
import expandIcon from '../images/icon-expand.svg';
import posed, { PoseGroup } from 'react-pose';
import { Link, animateScroll as scroll } from 'react-scroll';

const IconPress = posed.img({
    hoverable: true,
    pressable: true,
    init: {
        y: 0,
    },
    press: {
        y: 15,
    },
    hover: {
        fill: '#fff',
    },
});

const HeroStyled = styled.div`
    display: flex;
    color: white;
    justify-content: ${props => (props.isSubPage ? 'left' : 'center')};
    position: relative;
    width: 100%;
    .hero-image {
        position: relative;

        width: 100%;

        img {
            width: 100%;
            ${props => (props.isSubPage ? 'height: 460px' : '')};
        }

        @media screen and (max-width: 768px) {
            top: 0px;

            img {
                ${props => (props.isSubPage ? 'height: 244px' : '')};
            }
        }
    }

    .hero-content {
        position: absolute;
        display: flex;
        flex-direction: column;

        ${props =>
            props.isSubPage
                ? `padding-bottom: 190px; align-self: flex-end; align-items: flex-start; text-align: left; margin-left: 10%;`
                : `margin-top: 192px; top: 0; align-items: center; text-align: center; width: 50%;`}

        h1 {
            margin-top: 52px;
            font-size: 60px;
            font-weight: bold;
            font-style: italic;
            min-width: 716px;
            letter-spacing: 1.56px;

            @media screen and (min-width: 768px) {
                letter-spacing: 2.8px;
            }
        }
        p {
            margin-top: 25px;
            font: 400 18px roboto, sans-serif;
            line-height: 34px;
            color: #e4e2db;
        }

        .logo-position {
            width: 80%;
            max-width: 800px;
        }

        .expand-position {
            margin-top: 40px;
        }

        @media screen and (max-width: 1300px) {
            ${props =>
                props.isSubPage
                    ? 'padding-bottom: 180px; align-self: flex-end;'
                    : 'margin-top: 112px; '}
            .logo-position {
                width: 80%;
                max-width: 600px;
            }
            h1 {
                font-size: 48px;
                margin-top: 25px;
            }

            p {
                font-size: 14px;
                margin-top: 20px;
            }

            .expand-position {
                margin-top: 25px;
            }
        }
        @media screen and (max-width: 1024px) {
            ${props => (props.isSubPage ? '' : 'margin-top: 70px ')}
        }
        @media screen and (max-width: 768px) {
            ${props =>
                props.isSubPage
                    ? 'width: 90%; padding-bottom: 70px; align-self: flex-end;'
                    : 'width: 80%; margin-top: 190px;'}
            h1 {
                margin-top: 38px;
                font-size: 28px;
                min-width: auto;
            }

            p {
                font-size: 14px;
            }
        }
    }
`;

const Hero = ({ headerText, background, text, showLogo, isSubPage }) => (
    <HeroStyled isSubPage={isSubPage}>
        <div className="hero-image">
            <img src={background} alt="hero background"></img>
        </div>
        <div className="hero-content">
            {showLogo ? (
                <div className="logo-position">
                    <PilotCompanyLogo></PilotCompanyLogo>
                </div>
            ) : (
                <></>
            )}
            {text ? <p>{text}</p> : <></>}
            {isSubPage ? (
                <></>
            ) : (
                <Link href='' to="video" smooth={true} offset={-80}>
                    <IconPress
                        className="expand-position"
                        src={expandIcon}
                        alt="expand icon"
                        aria-label="Expand the content"
                    ></IconPress>
                </Link>
            )}
        </div>
    </HeroStyled>
);

Hero.propTypes = {
    headerText: PropTypes.string.isRequired,
    background: PropTypes.string.isRequired,
    text: PropTypes.string,
    showLogo: PropTypes.bool,
    isSubPage: PropTypes.bool,
};

Hero.defaultProps = {
    text: '',
    showLogo: true,
    isSubPage: false,
};

export default Hero;
